@if (dataSource) {
    <div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
        <div class="card-header d-flex align-items-center justify-content-between">
            <span class="fs-5 fw-medium">Nestle Deactivation History</span>
            <dx-button text="Export" icon="export" stylingMode="outlined" type="default" (onClick)="export()"></dx-button>
        </div>
        <div class="card-body">
            <dx-data-grid
                class="theme-dependent"
                noDataText=""
                [dataSource]="dataSource"
                [remoteOperations]="true"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                width="100%"
            >
                <dxo-paging [pageSize]="5"></dxo-paging>
                <dxo-pager [visible]="true" displayMode="full" [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showNavigationButtons]="true"></dxo-pager>
                <dxo-load-panel [showPane]="false"></dxo-load-panel>

                <dxi-column [dataField]="gridFieldName('effectiveDate')" caption="Effective Date" dataType="date"></dxi-column>
                <dxi-column [dataField]="gridFieldName('positionDelimited')" caption="ID Delimited?"
                            [lookup]="{ dataSource: yesNoOptions, valueExpr: 'value', displayExpr: 'text' }"></dxi-column>
                <dxi-column [dataField]="gridFieldName('type')" caption="Type" cellTemplate="type"
                            [lookup]="{ dataSource: typeOptions, valueExpr: 'value', displayExpr: 'text' }"></dxi-column>
                <dxi-column dataField="createdBy.name" caption="User" cellTemplate="user" [minWidth]="220"></dxi-column>
                <dxi-column [dataField]="gridFieldName('created')" caption="Date" dataType="datetime" sortOrder="desc"></dxi-column>
                <dxi-column type="buttons" caption="Actions">
                    <dxi-button icon="eyeopen" hint="View" [onClick]="onView"></dxi-button>
                </dxi-column>

                <div *dxTemplate="let cellInfo of 'type'">
                    <span class="badge" [ngClass]="getTypeBadgeClass(cellInfo.value)">{{ cellInfo.text }}</span>
                </div>
                <div *dxTemplate="let cellInfo of 'user'">
                    @if (getCellData(cellInfo).createdBy; as user) {
                        <user-avatar-email [email]="user.email" [name]="user.name" [avatarUrl]="user.avatarUrl" [employeeId]="user.id"></user-avatar-email>
                    }
                </div>
            </dx-data-grid>
        </div>
    </div>

    <user-status-update-popup
        [userId]="userId"
        [record]="selectedRow"
        [(visible)]="isPopupOpened"
    ></user-status-update-popup>
}
